import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import Modalheader from '../../../components/header';
import React, { useEffect, useState } from 'react';
import ModalFooter from '../../../components/footer';
import Button from '../../../../button';
import ModalBody from '../../../components/body';
import StyledInput from '../../../../styledInput/StyledInput';
import ApiDatabase from '../../../../../server';
import { toast } from 'react-toastify';

const ModalSundayHoursCompany = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);
  const [isWaitingBonusList, setIsWaitingBonusList] = useState(false);
  const [sundayBonus, setSundayBonus] = useState(null);
  const [isActive, setIsActive] = useState(false);

  const token = localStorage.getItem('xsrfToken');

  const handleSubmit = () => {
    if (modalData?.idCompany && sundayBonus) {
      setIsLoading(true);
      const increase = isActive ? sundayBonus.value : null;
      ApiDatabase.postSundayHoursCompany(
        { token, idCompany: modalData?.idCompany, increase },
        (data) => {
          setIsLoading(false);
          toast.success(
            isActive
              ? 'La majoration des heures de dimanche a été activée'
              : 'La majoration des heures de dimanche a été désactivée'
          );
          setModalDataReturn({
            type: 'sunday_hours_updated',
            increase,
          });
          toggle();
        },
        (err) => {
          if (err.name !== 'CanceledError') {
            console.log(err);
            setIsLoading(false);
          }
        }
      );
    }
  };

  useEffect(() => {
    if (!modalData?.idCompany) return;

    setIsWaitingBonusList(true);
    ApiDatabase.getBonusListCompany(
      { token, idCompany: modalData.idCompany },
      (data) => {
        // Préférer l'intitulé exact "HEURES DIMANCHE"
        const exactSunday = data.bonusList.find(
          (bonus) => bonus.name && bonus.name.trim().toUpperCase() === 'HEURES DIMANCHE'
        );
        // Sinon un intitulé commençant par "HEURES DIMANCHE" et sans "FERIE"
        const fallbackSunday =
          exactSunday ||
          data.bonusList.find(
            (bonus) =>
              bonus.name &&
              bonus.name.toUpperCase().startsWith('HEURES DIMANCHE') &&
              !bonus.name.toUpperCase().includes('FERIE')
          );

        if (fallbackSunday) {
          setSundayBonus({
            value: fallbackSunday._id,
            label: fallbackSunday.name,
          });
        }
        setIsWaitingBonusList(false);
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          console.error(err);
          setIsWaitingBonusList(false);
        }
      }
    );

    setIsWaiting(true);
    ApiDatabase.getSundayHoursCompany(
      { token, idCompany: modalData.idCompany },
      (data) => {
        setIsActive(!!data.sundayHours);
        // Si sundayHoursDetails est disponible, mettre à jour le bonus
        if (data.sundayHoursDetails && !sundayBonus) {
          setSundayBonus({
            value: data.sundayHoursDetails._id,
            label: data.sundayHoursDetails.name,
          });
        }
        setIsWaiting(false);
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          console.error(err);
          setIsWaiting(false);
        }
      }
    );
  }, [modalData?.idCompany]);

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Heures du dimanche
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-2.5 text-sm">
          {isWaiting || isWaitingBonusList ? (
            <div className={'animate-pulse'}>
              <div className={'h-16 bg-gray-200 rounded w-full'}></div>
            </div>
          ) : (
            <>
              <div className="p-4 border rounded">
                <div className="text-sm text-gray-700">
                  {isActive
                    ? 'La majoration des heures de dimanche est actuellement activée.'
                    : 'La majoration des heures de dimanche est actuellement désactivée.'}
                </div>
                {sundayBonus && (
                  <div className="text-xs text-gray-500 mt-2">
                    Bonus: {sundayBonus.label}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        {isLoading ? (
          <>
            <Button size={'LG'} color={'SECONDARY'}>
              Annuler
            </Button>
            <Button size={'LG'} color={'DISABLED'}>
              Confirmation ...
            </Button>
          </>
        ) : (
          <>
            <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
              Annuler
            </Button>
            <Button size={'LG'} color={'PRIMARY'} onClick={handleSubmit}>
              Confirmer
            </Button>
          </>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalSundayHoursCompany;
